import { render, staticRenderFns } from "./PlayerApp.vue?vue&type=template&id=01f2ef36&"
import script from "./PlayerApp.vue?vue&type=script&lang=ts&"
export * from "./PlayerApp.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports